import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProjectComment } from "@/types/project";
import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { mapProjectCommentsToCommentRead } from "../utils/mapProjectCommentsToCommentRead";
import type { CommentRead } from "@/schemas/comments";
import { CommentsList } from "@/modules/comments";

interface ProjectCommentsSectionProps {
  comments: ProjectComment[];
  isPending?: boolean;
}

export const ProjectCommentsSection = ({
  comments,
  isPending = false,
}: ProjectCommentsSectionProps) => {
  const { t } = useTranslation();
  const name = "projectComments";

  const staticComments = useMemo(
    () => mapProjectCommentsToCommentRead(comments),
    [comments],
  );
  const options = useCreateDataTableOptions<CommentRead>(name);

  if (staticComments.length === 0 && !isPending) {
    return null;
  }

  return (
    <CommentsList
      staticComments={staticComments}
      staticCommentsLoading={isPending}
      options={options}
      title={t("projects.comments.title")}
      name={name}
    />
  );
};
